import { render, staticRenderFns } from "./ClientStatus.vue?vue&type=template&id=4732c6e2&scoped=true"
import script from "./ClientStatus.vue?vue&type=script&lang=js"
export * from "./ClientStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732c6e2",
  null
  
)

export default component.exports